(function () {
    "use strict";

    angular.module("alk.accountManagement", [])
    .constant("alk.accountManagement.config", {
        addUserUrl: "/api/ManageAccount/AddUser",
        removeUserUrl: "/api/ManageAccount/RemoveUser",
        changeUserRoleUrl: "/api/ManageAccount/ChangeUserRole",
        getUsersUrl: "/api/ManageAccount/GetUsersInAccount",
        changeEnabledUrl: "/api/ManageAccount/ChangeUserEnabled"
    })
    .provider("AccountManagement", ["alk.accountManagement.config", function (config) {
        Object.defineProperties(this, {
            addUserUrl: {
                get: function () { return config.addUserUrl; },
                set: function (value) { config.addUserUrl = value; }
            },
            removeUserUrl: {
                get: function () { return config.removeUserUrl; },
                set: function (value) { config.removeUserUrl = value; }
            },
            getUsersUrl: {
                get: function () { return config.getUsersUrl; },
                set: function (value) { config.getUsersUrl = value; }
            },
            changeUserRoleUrl: {
                get: function () { return config.changeUserRoleUrl; },
                set: function (value) { config.changeUserRoleUrl = value; }
            },
            changeEnabledUrl: {
                get: function () { return config.changeEnabledUrl; },
                set: function (value) { config.changeEnabledUrl = value; }
            }
        });

        this.$get = ["$q", "$http", function ($q, $http) {
            function addUser(user) {
                return $http.post(config.addUserUrl, user);
            }

            function removeUser(user) {
                return $http.post(config.removeUserUrl, user);
            }

            function changeUserRole(userRole) {
                var deferred = $q.defer();

                $http.post(config.changeUserRoleUrl, userRole).success(function (resp) {
                    deferred.resolve(resp.role);
                }).error(function (err) {
                    deferred.reject(err);
                });

                return deferred.promise;
            }

            function getUsers(pagingParam, includeDisabled) {
                var deferred = $q.defer();

                pagingParam.params.includeDisabled = includeDisabled === true;

                $http.get(config.getUsersUrl, pagingParam)
                    .success(function (resp) {

                        deferred.resolve({
                            total: resp.Total,
                            users: _.map(resp.Results, function (item) {
                                item.isAdmin = item.RoleName === "Company Administrator";
                                return item;
                            })
                        });

                    }).error(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            function changeEnabled(toggleAccess) {
                var deferred = $q.defer();

                $http.post(config.changeEnabledUrl, toggleAccess).success(function (resp) {
                    deferred.resolve();
                }).error(function (err) {
                    deferred.reject(err);
                    return $q.reject(err);
                });

                return deferred.promise;
            }

            var service = {
                addUser: addUser,
                removeUser: removeUser,
                changeUserRole: changeUserRole,
                getUsers: getUsers,
                changeEnabled: changeEnabled
            };

            return service;
        }];
    }]);

})();



// WEBPACK FOOTER //
// ./app/alk-common/alkAccountManagement.js